/*
 *   File : confirm-logout.js
 *   Author : https://evoqins.com
 *   Description : Restart cancelled sip modal component
 *   Integrations : NA
 *   Version : 1.0.0
*/

// Components
import { PrimaryButton } from "../Buttons";
import { Icon } from "../Icon"

function ConfirmLogoutModal(props) {

    // handle close modal
    const _handleCloseModal = () => {
        var button = document.getElementById("confirm-logout-modal-close");
        button.click();
        props.handleClose();
    };

    // handle success
    const _handleSuccess = () => {
        var button = document.getElementById("confirm-logout-modal-close");
        button.click();
        props.handleSuccess();
    };

    return (
        <div className="modal fade"
            id="confirm-logout-modal"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabIndex="-1"
            aria-labelledby="SipRestartModalLabel"
            aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable border-radius-16 modal-lg px-lg-5">
                <span id='confirm-logout-modal-close' className='d-none' data-bs-dismiss="modal"></span>
                <div className="modal-content border-radius-16 border-0 mx-lg-5">
                    {/* modal header */}
                    <div className="modal-header border-0 justify-content-end align-items-center pt-3 px-3 pb-0">
                        <Icon icon="close-icon"
                            size="20px"
                            className="cursor-pointer"
                            onPress={_handleCloseModal} />
                    </div>

                    {/* Modal body */}
                    <div className='modal-body py-0 px-3 text-center'>
                        <img src={require("../../Assets/Images/Modal/logout.png")}
                            draggable={false}
                            width={200}
                            alt='logout' />

                        <h4 className='e-font-16-res padding-12px-top mb-2 e-text-primary-color e-primary-font-clash-display e-font-18 e-font-weight-500 line-height-22px'>
                            Are your sure you want to Log Out?
                        </h4>
                        <p className='px-5 mb-0 e-alt-font-lato e-font-14 e-text-outer-space e-font-weight-400 line-height-20px'>
                            Logging out will end your current session. You can always log back in to continue managing your investments.                        </p>
                    </div>
                    {/* Modal footer */}
                    <div className='modal-footer border-0 padding-40px-lr padding-20px-tb d-block'>
                        <PrimaryButton name="Log Out"
                            className="w-100 flex-fill e-letter-spacing-min-point-1px e-font-16 e-font-14-res"
                            padding="padding-18px-tb e-padding-8px-all-res"
                            onPress={_handleSuccess} />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ConfirmLogoutModal;